import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.css'
})
export class   CookieConsentComponent implements OnInit {
    isVisible = false;
  showSettingsModal = false;
  private hasConsent = false;

  // 👇 User's granular preferences
  cookiePreferences = {
    necessary: true, // always true
    analytics: false,
    advertising: false
  };

  ngOnInit() {
    this.checkConsentStatus();
  }

  // React when localStorage changes (e.g., user manually clears it)
  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if (event.key === 'cookieConsent' && event.newValue === null) {
      this.isVisible = true;
      this.hasConsent = false;
    }
  }

  private checkConsentStatus() {
    const consentGiven = localStorage.getItem('cookieConsent');
    const savedPrefs = localStorage.getItem('cookiePreferences');

    if (!consentGiven) {
      setTimeout(() => (this.isVisible = true), 800);
    } else {
      this.hasConsent = consentGiven === 'accepted';
      this.isVisible = false;
    }

    if (savedPrefs) {
      this.cookiePreferences = JSON.parse(savedPrefs);
    }
  }

  acceptCookies() {
    this.cookiePreferences = { necessary: true, analytics: true, advertising: true };
    this.saveConsent('accepted');
    this.initializeTrackingCookies();
  }

  rejectCookies() {
    this.cookiePreferences = { necessary: true, analytics: false, advertising: false };
    this.saveConsent('rejected');
    this.removeTrackingCookies();
  }

  private saveConsent(status: string) {
    localStorage.setItem('cookieConsent', status);
    localStorage.setItem('cookiePreferences', JSON.stringify(this.cookiePreferences));
    this.hasConsent = status === 'accepted';
    this.setCookie('user_cookie_consent', status, 365);
    this.isVisible = false;
  }

  private setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  private initializeTrackingCookies() {
    if (this.hasConsent && this.cookiePreferences.analytics) {
      console.log('✅ Analytics cookies enabled');
    }
    if (this.hasConsent && this.cookiePreferences.advertising) {
      console.log('✅ Advertising cookies enabled');
    }
  }

  private removeTrackingCookies() {
    const cookies = document.cookie.split(';');
    cookies.forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (['_ga', '_gid', '_fbp', '_fbc'].some(prefix => name.startsWith(prefix))) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
      }
    });
  }

  hasUserConsented(): boolean {
    return this.hasConsent;
  }

  // ⚙️ Show settings modal
  showCookieSettings() {
    this.showSettingsModal = true;
  }

  // 👇 Close modal
  closeSettings() {
    this.showSettingsModal = false;
  }

  // 👇 Save user’s selected preferences
  saveSettings() {
    localStorage.setItem('cookiePreferences', JSON.stringify(this.cookiePreferences));
    // If user enables any non-necessary cookies, treat as accepted
    const accepted =
      this.cookiePreferences.analytics || this.cookiePreferences.advertising;
    this.saveConsent(accepted ? 'accepted' : 'rejected');
    console.log('Cookie preferences saved:', this.cookiePreferences);
    this.closeSettings();
  }
}
